import { IAddUser } from "@types";
import { client } from "./client";

const baseUrl = "/users";

export interface UserConfig {
  keyMap: string[];
  controlKey?: string[];
  settings?: Record<string, unknown>;
}

export const getUsers = async () => {
  try {
    const response = await client.get(`${baseUrl}`);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const createUser = async (userInfo: IAddUser) => {
  try {
    const response = await client.post(`${baseUrl}`, userInfo);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const editUser = async (userInfo: IAddUser) => {
  try {
    const response = await client.patch(`${baseUrl}`, userInfo);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const getUserConfig = async (userId: number) => {
  try {
    const response = await client.get(`${baseUrl}/${userId}/config`);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const updateUserConfig = async (userConfig: UserConfig, userId: number) => {
  try {
    const response = await client.put(`${baseUrl}/${userId}/config`, userConfig);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const getUserInfo = async (userId: number) => {
  try {
    const response = await client.get(`${baseUrl}/${userId}/myInfo`);
    return response.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const cborTest = async () => {
  try {
    const response = await client.get(`/cbor-test`);
    return response.data;
  } catch (error: any) {
    console.error("CBOR test error:", error);
  }
};

export const getSystemConfig = async () => {
  try {
    const response = await client.get(`${baseUrl}/config`);
    return response.data;
  } catch (error) {
    console.error("Error fetching system config:", error);
    throw error;
  }
};
